import apiClient from '../../shared/services/apiClient';

/** 后台：用户的产品 + 替用户开通 / 改套餐 / 改到期 / 结束（/api/admin/users/products, /api/admin/subscriptions/*） */
const call = async (fn) => {
    try {
        const r = await fn();
        return r.data;
    } catch (e) {
        return e.response?.data || { success: false, error: e.message };
    }
};

const adminProductService = {
    list: (userId, includeEnded = false) => call(() => apiClient.get('/api/admin/users/products', { params: { user_id: userId, include_ended: includeEnded ? 1 : 0 } })),
    options: (userId, type) => call(() => apiClient.get('/api/admin/users/products/options', { params: { user_id: userId, type } })),
    provision: (data) => call(() => apiClient.post('/api/admin/users/products/provision', data)),
    byResource: (type, id) => call(() => apiClient.get('/api/admin/subscriptions/by-resource', { params: { type, id } })),
    planOptions: (subscriptionId) => call(() => apiClient.get('/api/admin/subscriptions/plan-options', { params: { id: subscriptionId } })),
    changePlan: (id, productId, mode, billingCycle) => call(() => apiClient.post('/api/admin/subscriptions/change-plan', { id, product_id: productId, mode, billing_cycle: billingCycle || undefined })),
    update: (id, data) => call(() => apiClient.post('/api/admin/subscriptions/admin-update', { id, ...data })),
    end: (id, when, reason) => call(() => apiClient.post('/api/admin/subscriptions/end', { id, when, reason })),
    suspend: (id) => call(() => apiClient.post('/api/admin/subscriptions/suspend', { id, reason: '管理员暂停' })),
    resume: (id) => call(() => apiClient.post('/api/admin/subscriptions/resume', { id, reason: '管理员恢复' })),
    manage: (id) => call(() => apiClient.get('/api/admin/subscriptions/manage', { params: { id } })),
    setOverrides: (id, features) => call(() => apiClient.post('/api/admin/subscriptions/overrides', { id, features })),
    grantAddon: (id, productId, quantity) => call(() => apiClient.post('/api/admin/subscriptions/addon-grant', { subscription_id: id, product_id: productId, quantity })),
    cancelAddon: (childId) => call(() => apiClient.post('/api/admin/subscriptions/addon-cancel', { child_id: childId })),
};

export default adminProductService;
